<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text>
          <v-row>
            <!-- <v-col cols="4" v-if="fileAdministrasi !== ''">
              <v-label>Dokumen Administrasi</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileAdministrasi', fileAdministrasi, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col>
            <v-col cols="4" v-if="fileTeknis !== ''">
              <v-label>Dokumen Teknis</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileTeknis', fileTeknis, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col> -->
            <v-col cols="4" v-if="fileSDP !== ''">
              <v-label>Standar Dokumen Pengadaan</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileSDP', fileSDP, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col>
            <v-col cols="4" v-if="fileTambahan !== ''">
              <v-label>Dokumen Tambahan</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileTambahan', fileTambahan, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>


<script>
import { TenderLib } from "./../../../lib/tenderLib";
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API


export default {
    data() {
        return {
            tenderLib: TenderLib,
            // fileAdministrasi: "",
            // fileTeknis: "",
            fileSDP: "",
            fileTambahan: ""
        }
    },
  
    computed: {
        paket: function() {
            return this.$store.getters['lelang/paket']
        },
    },

    watch: {
        paket() {
            this.getData();
        }
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        axios.get(`${apiUrl}/api/rup/lelang/prakualifikasi/tender-files/${this.paket.id}`)
        .then( (response) => {
            // this.fileAdministrasi = response.data.fileAdministrasi;
            // this.fileTeknis = response.data.fileTeknis;
            this.fileSDP = response.data.fileSDP;
            this.fileTambahan = response.data.fileTambahan;
        })
        .catch( (error) => {
            console.error(error);
            return error;
        });
      }
    }
}
</script>


<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>
